import { buildPropertyObjectTagPresentation } from "../../../../../_shared/_logic/object-tags"
import { buildAppointmentTimeTagPresentation } from "../../../../../../../_shared/_logic/appointment-time-tags"
import { buildWorkOrderSummaryTagPresentation } from "../../../../../_shared/_logic/summary-tag"
import type { CancelReplanRow } from "../cancel-replan-contract"

export const buildCancelReplanAppointmentTag = (event?: ScheduleEvent | null) =>
  event
    ? buildAppointmentTimeTagPresentation({
        start_at: event.start_at,
        end_at: event.end_at,
        flex_type: event.flex_type,
        timeframe_start_at: event.timeframe_start_at,
        timeframe_end_at: event.timeframe_end_at,
        customer_window_start_at: event.customer_window_start_at,
        customer_window_end_at: event.customer_window_end_at,
      })
    : null

export const buildCancelReplanWorkOrderTag = (workOrder?: WorkOrder | null) =>
  buildWorkOrderSummaryTagPresentation({ workOrder })

export const buildCancelReplanPropertyTag = (row: CancelReplanRow) =>
  buildPropertyObjectTagPresentation({
    property: row.property,
    propertyUnitId: row.workOrder?.property_unit_id ?? null,
    mode: "address-first",
  })
